import React from 'react';
import { Link } from 'gatsby';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import logo from '../../images/logo.png';

const activeNavStyle = {
  color: '#af3f42',
};

export default () => (
  <>
    <Navbar expand="lg" className="navigation container">
      <Navbar.Brand
        as={Link}
        to="/"
        className="text-decoration-none d-flex justify-content-center align-items-center py-0"
      >
        <img
          src={logo}
          alt="한국직업개발원 로고"
          className="header-logo mb-0"
          style={{ width: '150px' }}
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="navbarNavAltMarkup"></Navbar.Toggle>
      <Navbar.Collapse
        className="justify-content-end align-items-center mt-0"
        id="navbarNavAltMarkup"
      >
        
        {/* <Nav className="gnb-internal-links mx-auto">
          <Nav.Link
            as={Link}
            to="/menu01/"
            activeStyle={activeNavStyle}
            partiallyActive={true}
            className="py-0 px-3"
          >
            menu01
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/menu02/"
            activeStyle={activeNavStyle}
            partiallyActive={true}
            className="p-0 px-3"
          >
            menu02
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/menu03/"
            activeStyle={activeNavStyle}
            className="p-0 px-3"
          >
            menu03
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/menu04/"
            activeStyle={activeNavStyle}
            className="p-0 px-3"
          >
            menu04
          </Nav.Link>
        </Nav> */}

        <Nav className="gnb-external-links">
          <Nav.Link
            href="https://company.hrdcen.com/"
            className="py-0 m-0"
            target="_blank"
            rel="noreferer noopener"
          >
            회사소개
          </Nav.Link>
          <Nav.Link
            href="https://info.hrdcen.com/"
            className="py-0 m-0"
            target="_blank"
            rel="noreferer noopener"
          >
            환급제도 안내
          </Nav.Link>
          <Nav.Link
            href="https://notice.hrdcen.com/"
            className="py-0 m-0"
            target="_blank"
            rel="noreferer noopener"
          >
            공지사항
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  </>
);
